import { SummaryModel } from '../models/Summary.model';

export function getPaymentAmount(summary: SummaryModel) {
  return summary.payNow?.amount || /* istanbul ignore next */ '0';
}
